import { ViewStyle } from "react-native";
import { enumNever } from "src/shared/helpers/generalHelpers";
import { CommentBubbleSmallRadius } from "../constants";
import { CommentBubbleProps } from "../types";

const parseCommentBubbleRadiusOverrides = ({
	position,
	sender,
}: {
	position: NonNullable<CommentBubbleProps["position"]>;
	sender: NonNullable<CommentBubbleProps["sender"]>;
}): ViewStyle => {
	switch (sender) {
		case "Self":
			switch (position) {
				case "Top":
					return {
						borderBottomRightRadius: CommentBubbleSmallRadius,
					};
				case "Middle":
					return {
						borderBottomRightRadius: CommentBubbleSmallRadius,
						borderTopRightRadius: CommentBubbleSmallRadius,
					};
				case "Bottom":
					return {
						borderTopRightRadius: CommentBubbleSmallRadius,
					};
				default:
					return enumNever(position);
			}
		case "Other":
			switch (position) {
				case "Top":
					return {
						borderBottomLeftRadius: CommentBubbleSmallRadius,
					};
				case "Middle":
					return {
						borderBottomLeftRadius: CommentBubbleSmallRadius,
						borderTopLeftRadius: CommentBubbleSmallRadius,
					};
				case "Bottom":
					return {
						borderTopLeftRadius: CommentBubbleSmallRadius,
					};
				default:
					return enumNever(position);
			}
		default:
			return enumNever(sender);
	}
};

export default parseCommentBubbleRadiusOverrides;
